import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Globe } from "lucide-react";

const Footer = () => {
  const galleryImages = [
    { id: 1, url: "images/landing/blog_page/news-1.jpg", alt: "Image 1" },
    { id: 2, url: "images/landing/blog_page/news-2.jpg", alt: "Image 2" },
    { id: 3, url: "images/landing/blog_page/news-3.jpg", alt: "Image 3" },
    { id: 4, url: "images/landing/blog_page/news-3.jpg", alt: "Image 4" },
    { id: 5, url: "images/landing/blog_page/news-2.jpg", alt: "Image 5" },
    { id: 6, url: "images/landing/blog_page/news-1.jpg", alt: "Image 6" },
    { id: 7, url: "images/landing/blog_page/news-2.jpg", alt: "Image 7" },
    { id: 8, url: "images/landing/blog_page/news-1.jpg", alt: "Image 8" },
    { id: 9, url: "images/landing/blog_page/news-3.jpg", alt: "Image 9" },
  ];

  return (
    <footer className="bg-deep text-white py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between md:gap-8 lg:gap-52">
          {/* Company Info */}
          <div className="w-full md:w-1/3 mb-8 md:mb-0">
            <img
              src="/images/logo.svg"
              alt="ADHIM"
              className="h-24 md:h-32 mb-4"
            />
            <p className="text-sm">
              Corrosion and Energy are things that cannot be enjoyed. Corrosion
              is degradation. We know that metals produced from reduced metal
              oxides use energy to get metals. When the metal rusts without us
              knowing there is energy lost to nature.
            </p>
          </div>

          {/* Services and Contact */}
          <div className="w-full md:w-2/3 grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Best Service */}
            <div className="mb-8 md:mb-0">
              <h3 className="font-bold mb-4">Best Service</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/about" className="hover:text-primary">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/service" className="hover:text-primary">
                    Service
                  </Link>
                </li>
                <li>
                  <Link to="/product" className="hover:text-primary">
                    Product
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="hover:text-primary">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-primary">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Our Gallery */}
            {/* <div className="mb-8 md:mb-0">
              <h3 className="font-bold mb-4">Our Gallery</h3>
              <div className="grid grid-cols-3 gap-2">
                {galleryImages.slice(0, 6).map((image) => (
                  <div key={image.id} className="aspect-square overflow-hidden">
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </div> */}

            {/* Contact Info */}
            <div>
              <h3 className="font-bold mb-4">Contact Info</h3>
              <ul className="mb-4 space-y-2 text-sm">
                <li>
                  <p>Bandung, Indonesia</p>
                  <p>Jl. Cilengkrang 1 No.99B RT.001 RW.005</p>
                </li>
                <li>Kel. Cisurupan, Kec. Cibiru</li>
              </ul>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center gap-2">
                  <Phone size={16} /> <span>+62 22 63762757</span>
                </li>
                <li className="flex items-center gap-2">
                  <Mail size={16} /> <span>info@adhimaju.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <Globe size={16} /> <span>www.adhimaju.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 md:mt-20 pt-8 border-t border-gray-400 text-center text-sm">
          Copyright ©2024 PT Adhim Aju Sejahtera | All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
